import React from 'react';
import { Box, ResponsiveContext } from 'grommet';
import { Heading } from '../components/Heading';
import { useHomeContext } from '../contexts/HomeContext';
import { DataTable, InputFilter } from '../components';
import {
  filterByContributions,
  filterByFollowers,
  filterByGists,
  filterByRepos,
} from '../actions/Home';

const Home = () => {
  const {
    state: { dataTable, loading },
    dispatch,
  } = useHomeContext();

  const onSort = (option: string) => {
    switch (option) {
      case 'contributions':
        dispatch(filterByContributions());
        break;
      case 'repos':
        dispatch(filterByRepos());
        break;
      case 'followers':
        dispatch(filterByFollowers());
        break;
      case 'gists':
        dispatch(filterByGists());
        break;
      default:
        return;
    }
  };

  return (
    <ResponsiveContext.Consumer>
      {(size) => (
        <Box animation="fadeIn">
          <Box align="center" margin="small">
            <Heading size={size === 'xsmall' ? 'large' : 'xlarge'} />
          </Box>
          <Box align="end" margin="small">
            <InputFilter
              options={['contributions', 'repos', 'gists', 'followers']}
              placeholder="Sort by"
              onSort={onSort}
            />
          </Box>
          <DataTable
            columns={dataTable.columns}
            data={dataTable.data}
            loading={loading}
          />
        </Box>
      )}
    </ResponsiveContext.Consumer>
  );
};

export { Home };
